/**
 * NestJs CrudValidationGroups have no DELETE entry,
 * so this file applies some trickery to add it to the enum.
 * As of 2022-05, repo code uses the custom CrudAction enum only.
 *
 * CrudValidationGroups.DELETE is not used anymore, so the code was commented out.
 * But the added DELETE entry stays added to make sure nothing breaks because of incompatibilities.
 */
// found this solution at https://stackoverflow.com/questions/41940349/typescript-extending-imported-enum
// https://www.typescriptlang.org/docs/handbook/declaration-merging.html#module-augmentation
// import { CrudValidationGroups } from '@core/backend-shared';
// declare module '@core/backend-shared' {
//     // eslint-disable-next-line @typescript-eslint/no-shadow
//     export enum CrudValidationGroups {
// 		// @ts-ignore
// 		UPDATE = 'CRUD-UPDATE',
// 		// @ts-ignore
// 		CREATE = 'CRUD-CREATE',
// 		// @ts-ignore
// 		DELETE = 'CRUD-DELETE',
//     }
// }
// // https://stackoverflow.com/questions/46758049/extending-an-imported-enum-in-another-file-and-using-it
// const myEnumValues = CrudValidationGroups as any;
// myEnumValues["DELETE"] = "CRUD-DELETE";
// export * from '@core/backend-shared';
export var CrudAction = /*#__PURE__*/function (CrudAction) {
  CrudAction["UPDATE"] = "CRUD-UPDATE";
  CrudAction["CREATE"] = "CRUD-CREATE";
  return CrudAction;
}(CrudAction || {});
export const AllCrudActions = [CrudAction.CREATE, CrudAction.UPDATE];